import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/service/auth.service';

export const consultationGuard: CanActivateFn = (route, state) => {
   const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.hasAccess('CONS')) {
    return true;
  }
  else{
    router.navigate(["/authentication/signin"]);
    return false;

  }
};
